import React, { createContext, useContext, useState, ReactNode } from 'react';

// ビューの種類（profileを削除）
export type ViewType = 'title' | 'film';

// コンテキストの型定義
interface ViewContextType {
  currentView: ViewType;
  setCurrentView: (view: ViewType) => void;
  isTransitioning: boolean;
  setIsTransitioning: (transitioning: boolean) => void;
}

// デフォルト値
const defaultContextValue: ViewContextType = {
  currentView: 'title',
  setCurrentView: () => {},
  isTransitioning: false,
  setIsTransitioning: () => {}
};

// コンテキスト作成
const ViewContext = createContext<ViewContextType>(defaultContextValue);

// カスタムフック
export const useView = () => {
  const context = useContext(ViewContext);
  if (!context) {
    throw new Error('useView must be used within a ViewProvider');
  }
  return context;
};

// プロバイダーコンポーネントの Props
interface ViewProviderProps {
  children: ReactNode;
}

// プロバイダーコンポーネント
export const ViewProvider: React.FC<ViewProviderProps> = ({ children }) => {
  const [currentView, setCurrentView] = useState<ViewType>('title');
  const [isTransitioning, setIsTransitioning] = useState(false);

  const value: ViewContextType = {
    currentView,
    setCurrentView,
    isTransitioning,
    setIsTransitioning
  };

  return (
    <ViewContext.Provider value={value}>
      {children}
    </ViewContext.Provider>
  );
};